module.exports = new __parcel__URL__("blockchain.20fdc75d.png").toString();